import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

function ViewShiftDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const shiftDetails = location.state?.shiftDetails || {};

  return (
    <div>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className='row text-end'>
                <div className='col'>
                  <button type="button" class="btn btn-danger"
                    style={{
                      backgroundColor: "rgb(236, 17, 23)"
                    }}
                    onClick={() => navigate("/shift-master")}
                  >
                    Back
                  </button>
                </div>
              </div>
              <h4 style={{ display: "flex", marginBottom: "30px" }}>
                Shift Details of :  {shiftDetails.shift_name}
              </h4>
              <div className="card">
                <div className="p-3">
                  <div className="text-start mb-3">
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Shift Name</label>
                          <input
                            type="text"
                            name="shift_name"
                            className="form-control"
                            readOnly
                            value={shiftDetails.shift_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Start Time</label>
                          <input
                            type="text"
                            name="start_time"
                            className="form-control"
                            readOnly
                            value={shiftDetails.start_time}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">End Time</label>
                          <input
                            type="text"
                            name="end_time"
                            className="form-control"
                            readOnly
                            value={shiftDetails.end_time}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Status</label>
                          <input
                            type="text"
                            className="form-control"
                            name="status"
                            readOnly
                            value={shiftDetails.status === "1" ? "Active" : "Inactive"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewShiftDetails
